import { render } from "./createTemplateProposalComponent.vue?vue&type=template&id=4b0c99cf&scoped=true"
import script from "./createTemplateProposalComponent.vue?vue&type=script&lang=js"
export * from "./createTemplateProposalComponent.vue?vue&type=script&lang=js"

import "./createTemplateProposalComponent.vue?vue&type=style&index=0&id=4b0c99cf&lang=css"
import "./createTemplateProposalComponent.vue?vue&type=style&index=1&id=4b0c99cf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0c99cf"]])

export default __exports__